// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function RejectedContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (rowContractData.status === 'Rejected' && rowContractData.contractLevel === 'Guild')
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="RejectedContractAvatar"
                    >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#424242'}}>r
                    </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
